export default { sha: '952aa2efaea22dd05b16c4bb71b1306cf48a52e0', buildNumber: 'undefined' }
